import CommentAutomationsAPI from '../../api/commentAutomations';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllAutomations(_state) {
    return _state.records;
  },
  getInstagramAutomations(_state) {
    return _state.records.filter(
      r => r.channel_type === 'Channel::Instagram' || (r.inbox_name && !r.channel_type?.includes('Facebook'))
    );
  },
  getFacebookAutomations(_state) {
    return _state.records.filter(
      r => r.channel_type === 'Channel::FacebookPage'
    );
  },
  getAutomationById: _state => id => {
    return _state.records.find(r => r.id === Number(id));
  },
};

export const mutations = {
  SET_AUTOMATIONS_UI_FLAG(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  SET_AUTOMATIONS(_state, data) {
    _state.records = data;
  },
  ADD_AUTOMATION(_state, data) {
    _state.records.unshift(data);
  },
  EDIT_AUTOMATION(_state, data) {
    const index = _state.records.findIndex(r => r.id === data.id);
    if (index !== -1) {
      _state.records.splice(index, 1, data);
    }
  },
  DELETE_AUTOMATION(_state, id) {
    _state.records = _state.records.filter(r => r.id !== Number(id));
  },
};

export const actions = {
  get: async function getAutomations({ commit }, params = {}) {
    commit('SET_AUTOMATIONS_UI_FLAG', { isFetching: true });
    try {
      const response = await CommentAutomationsAPI.get(params);
      const data = response.data.payload || response.data || [];
      commit('SET_AUTOMATIONS', data);
    } catch (error) {
      // Ignore or log error
    } finally {
      commit('SET_AUTOMATIONS_UI_FLAG', { isFetching: false });
    }
  },

  create: async function createAutomation({ commit }, data) {
    commit('SET_AUTOMATIONS_UI_FLAG', { isCreating: true });
    try {
      const response = await CommentAutomationsAPI.create({
        comment_automation: data,
      });
      const record = response.data.payload || response.data;
      commit('ADD_AUTOMATION', record);
      return record;
    } finally {
      commit('SET_AUTOMATIONS_UI_FLAG', { isCreating: false });
    }
  },

  update: async function updateAutomation({ commit }, { id, ...data }) {
    commit('SET_AUTOMATIONS_UI_FLAG', { isUpdating: true });
    try {
      const response = await CommentAutomationsAPI.update(id, {
        comment_automation: data,
      });
      const record = response.data.payload || response.data;
      commit('EDIT_AUTOMATION', record);
      return record;
    } finally {
      commit('SET_AUTOMATIONS_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async function deleteAutomation({ commit }, id) {
    commit('SET_AUTOMATIONS_UI_FLAG', { isDeleting: true });
    try {
      await CommentAutomationsAPI.delete(id);
      commit('DELETE_AUTOMATION', id);
    } finally {
      commit('SET_AUTOMATIONS_UI_FLAG', { isDeleting: false });
    }
  },

  toggleActive: async function toggleAutomationActive({ commit }, id) {
    try {
      const response = await CommentAutomationsAPI.toggleActive(id);
      const record = response.data.payload || response.data;
      commit('EDIT_AUTOMATION', record);
      return record;
    } catch (error) {
      throw error;
    }
  },

  fetchInboxPosts: async function fetchInboxPosts(
    _,
    { inboxId, limit, after, platform }
  ) {
    const response = await CommentAutomationsAPI.fetchInboxPosts(inboxId, {
      limit,
      after,
      platform,
    });
    return response.data;
  },

  sync: async function syncAutomations({ dispatch }, { id, inboxId } = {}) {
    const response = await CommentAutomationsAPI.sync(id, inboxId);
    dispatch('get');
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
